/**
 * Possible sort columns for comment api
 * GET /comment/v1/comments?sortBy=
 */
const CommentSortColumn = {
    CREATED_AT: 'created_at',
    REACTIONS: 'reactions',
    REACTIONS_BAD: 'reactions-bad',
    REACTIONS_NONSENSE: 'reactions-nonsense',
    REACTIONS_UNNECESSARY: 'reactions-unnecessary',
    REACTIONS_SMART: 'reactions-smart',
    REACTIONS_EXACT: 'reactions-exact',
    REACTIONS_AWESOME: 'reactions-awesome',
    REPLIES: 'replies'
};

/**
 * Possible sort directions for comment api
 * GET /comment/v1/comments?sortOrder=
 */
const CommentSortDirection = {
    ASC: 'asc',
    DESC: 'desc'
};

export {CommentSortColumn, CommentSortDirection};
